import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      try {
        setCart(JSON.parse(savedCart));
      } catch (e) {
        setCart([]);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (service, tier) => {
    const item = {
      service_id: service.id,
      service_name: service.name,
      tier_name: tier.name,
      price: tier.price,
      duration_months: tier.duration_months,
      category: service.category,
      quantity: 1,
      allow_quantity: service.allow_quantity || false,
    };
    
    // Check if item already exists
    const existingIndex = cart.findIndex(
      i => i.service_id === service.id && i.tier_name === tier.name
    );
    
    if (existingIndex >= 0 && item.allow_quantity) {
      // Increment quantity
      const newCart = [...cart];
      newCart[existingIndex].quantity = (newCart[existingIndex].quantity || 1) + 1;
      setCart(newCart);
    } else {
      setCart([...cart, item]);
    }
  };

  const removeFromCart = (index) => {
    setCart(cart.filter((_, i) => i !== index));
  };

  const updateQuantity = (index, quantity) => {
    if (quantity < 1) return;
    
    const newCart = [...cart];
    newCart[index] = { ...newCart[index], quantity };
    // Update price based on quantity
    if (newCart[index].base_price) {
      newCart[index].price = newCart[index].base_price * quantity;
    }
    setCart(newCart);
  };

  const clearCart = () => {
    setCart([]);
  };

  const getTotal = () => {
    return cart.reduce((sum, item) => {
      const quantity = item.quantity || 1;
      const unitPrice = item.base_price || item.price;
      return sum + (unitPrice * quantity);
    }, 0);
  };

  const getItemCount = () => {
    return cart.reduce((sum, item) => sum + (item.quantity || 1), 0);
  };

  return (
    <CartContext.Provider value={{ 
      cart, 
      setCart,
      addToCart, 
      removeFromCart, 
      updateQuantity,
      clearCart, 
      getTotal,
      getItemCount
    }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
}
